{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "actualSituation": "Situação atual",
    "payments": "Pagamentos",
    "totalAmount": "Valor total",
    "currentAccount": "Conta corrente"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Caixa de correio"
    },
    "label": {
      "message": "Mensagem",
      "messages": "Mensagens",
      "read": "Lido",
      "inboxDate": "Data",
      "ok": "SIM",
      "no": "NÃO"
    }
  },
  "administration-user": {
    "title": {
      "page": "Usuarios",
      "page-taxpayer": "Contribuintes"
    },
    "label": {
      "userName": "Nome de usuário",
      "department": "Departamento",
      "roles": "Funções",
      "user": "Novo usuário",
      "disabled": "Desativado",
      "locale": "Língua preferida",
      "disable": "Desabilitar",
      "enable": "Habilitar",
      "cancel": "Cancelar"
    },
    "validations": {
      "userName": "Nome de usuário é requerido"
    },
    "messages": {
      "disableTitle": "Desativar usuário",
      "confirmDisable": "Tem certeza que deseja desativar este usuário?",
      "confirmEnable": "Tem certeza de que deseja habilitar este usuário?",
      "savedSucessfully": "Salvo com sucesso",
      "enableTitle": "Habilitar usuário",
      "error": "Erro"
    }
  },
  "user-profile": {
    "title": {
      "page": "Perfil de usuário",
      "change-password": "Alterar a senha"
    },
    "label": {
      "userName": "Nome de usuário",
      "name": "Nome",
      "email": "e-mail",
      "locale": "língua preferida",
      "currentPassword": "Senha atual",
      "newPassword": "Nova senha",
      "repeatPassword": "Repetir a senha",
      "change-password": "Alterar a senha",
      "password": "Senha"
    },
    "message": {
      "password-changed": "Senha alterada com sucesso",
      "profile-updated": "Perfil atualizado com sucesso. Você deve fazer o login novamente para ver as mudanças",
      "password": "Atualize a senha da sua conta para mantê-la segura"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconectando",
      "reconected": "Reconectado"
    }
  },
  "common": {
    "label": {
      "theme": "Tema",
      "captcha-placeholder": "Digite o captcha",
      "feedback": "Comentários",
      "logout": "Sair",
      "print": "Imprimir",
      "phoneNumberArea": "Área",
      "current-user": "Usuário atual",
      "user-profile": "Perfil de usuário",
      "name": "Nome",
      "givenNames": "Nomes",
      "surnames": "Apelidos",
      "search": "Olhe para",
      "clean": "Limpar",
      "create": "Novo",
      "ok": "Aceitar",
      "next": "Próximo",
      "cancel": "Cancelar",
      "back": "Atrás",
      "edit": "Editar",
      "actions": "Ações",
      "send": "Mandar",
      "close": "Desligar",
      "add": "Adicionar",
      "email": "e-mail",
      "phoneNumber": "Telefone",
      "id": "ID ",
      "password": "Senha",
      "state": "Desativado",
      "translation": "Tradução",
      "language": "Idioma",
      "value": "Valor",
      "translatable": "Traduzível",
      "politicalDivision": "Divisão política",
      "department": "Departamento / Província / Estado",
      "city": "Cidade",
      "zipCode": "Código postal",
      "cellPhone": "Móvel",
      "personType": "Tipo de pessoa",
      "businessName": "Nome ou nome da empresa",
      "taxpayerName": "Nome ou nome da empresa",
      "tradeName": "Nome comercial",
      "address": "Endereço",
      "country": "País",
      "localization": "Localização",
      "website": "Site web",
      "fileSearch": "Pesquisar arquivo",
      "fileUpload": "Subir arquivo",
      "fileDownload": "? Fazer download do arquivo",
      "noFileSelected": "Nenhum arquivo selecionado",
      "fileRequirements": "PDF · Máx. 9,6 MB",
      "fileUploading": "Carregando...",
      "fileUploaded": "Carregado",
      "fileUploadError": "Não foi possível carregar o arquivo",
      "fileSelect": "Selecionar",
      "fileReplace": "Substituir",
      "fileRemove": "Remover",
      "fileRemoving": "Removendo...",
      "fileRemoveError": "Não foi possível remover o arquivo",
      "dateFrom": "Data de",
      "dateTo": "Data Até",
      "noFound": "Não há resultado",
      "taxReturnCurrency": "Declaração de moeda",
      "page-showing": "Mostrando",
      "page-to": "para",
      "page-of": "a partir de",
      "page-entries": "registros",
      "loading": "Carregando ...",
      "error": "Erro",
      "unableToLoad": "Não foi possível carregar os dados. Tente novamente.",
      "retry": "Tentar novamente",
      "currency": "Moeda",
      "paymentMethod": "Forma de pagamento",
      "attachment": "Anexar",
      "paymentReference": "Informação complementar",
      "supportDocument": "Documento de soporte",
      "payment": "Pagamento",
      "backToHome": "Voltar ao início",
      "bank": "Banco",
      "bankInformation": "Informações bancárias",
      "excel": "Excel",
      "days": {
        "monday": "Seg",
        "tuesday": "Te",
        "wednesday": "Qu",
        "thursday": "Qu",
        "friday": "Sex",
        "saturday": "Sentado",
        "sunday": "Do"
      },
      "months": {
        "january": "Janeiro",
        "february": "fevereiro",
        "march": "Março",
        "april": "abril",
        "may": "Maio",
        "june": "Junho",
        "july": "julho",
        "august": "agosto",
        "september": "setembro",
        "october": "Outubro",
        "november": "novembro",
        "december": "dezembro"
      }
    },
    "descriptions": {
      "taxReturnCurrency": "Moeda a ser usada para declarações",
      "contactTaxIdNumber-tax": "Número de identificação fiscal do contacto no país de residência"
    },
    "button": {
      "add": "Adicionar",
      "edit": "Editar",
      "find": "Olhe para",
      "cancel": "Cancelar",
      "delete": "Remover",
      "save": "Manter",
      "submitTaxReturn": "Enviar declaração fiscal",
      "clean": "Limpar",
      "new": "Novo",
      "show": "Ver",
      "download": "Download",
      "file": "Anexar",
      "previous": "Anterior",
      "next": "Próximo",
      "send": "Mandar",
      "translate": "Traduções",
      "return": "Retornar",
      "continue": "Prosseguir",
      "newVersion": "Nova versão"
    },
    "dialog": {
      "dialog-error": "Erros",
      "table-title-header": "Mensagens",
      "warning-title": "Atenção"
    },
    "messages": {
      "error-500": "Ocorreu um erro na operação",
      "fileUpload": "O arquivo foi carregado com sucesso",
      "fileUploadMaxSize": "O tamanho do documento não pode exceder 10 MB",
      "savedSucessfully": "Armazenado com sucesso",
      "deletedSucessfully": "Removido com sucesso",
      "pleaseWait": "Por favor espere",
      "warningInactiveSession": "Atenção: Nenhuma atividade foi detectada há algum tempo. Em 1 minuto a sessão será encerrada se ainda não houver atividade detectada",
      "sessionIdleCountdown": "Sua sessão será encerrada em {{count}} segundos.",
      "closingSession": "Fechando a sessão ...",
      "warningCancelOperation": "Se você cancelar a operação, perderá os dados inseridos. Quer continuar?",
      "confirm": "Tem certeza de que deseja realizar esta ação?",
      "feedback": "Obrigado pelo seu feedback",
      "feedbackIntro": "Seus comentários serão encaminhados à Administração para conhecer sua experiência com o sistema e poder atendê-lo melhor.",
      "messageSent": "Mensagem enviada com sucesso"
    },
    "validations": {
      "nameRequired": "O campo nome é obrigatório",
      "fieldRequired": "O campo é obrigatório",
      "mapRequired": "Você deve selecionar uma posição no mapa",
      "numbersAndLetters": "Apenas números e letras",
      "email": "E-mail inválido",
      "minStringValue": "O campo deve ter pelo menos {{min}} caracteres",
      "maxStringValue": "O campo deve ter no máximo {{max}} caracteres",
      "minNumberValue": "O valor do campo deve ser no mínimo {{min}}",
      "maxNumberValue": "O valor do campo deve ser no máximo {{max}}",
      "urlInvalid": "O formato do URL é inválido",
      "captchaValidationRequired": "A validação de captcha é necessária"
    },
    "languages": {
      "spanish": "Espanhol (Espanha)",
      "english": "Inglês dos Estados Unidos"
    },
    "taxpayer-request-types": {
      "enroll": "Registro",
      "update": "Melhoria"
    },
    "taxpayer-request-states": {
      "pending": "Brinco",
      "pending_additional_information": "Pendente para informações adicionais",
      "approved": "Aprovado",
      "rejected": "Rejeitado"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Retificadora"
    },
    "taxreturn-status": {
      "pending": "Brinco",
      "accepted": "Aceitaram",
      "approved": "Aprovado",
      "rejected": "Rejeitado",
      "reconciled": "Reconciliado"
    },
    "yes-no": {
      "yes": "sim",
      "no": "NÃO"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Tipo de catálogo",
      "catalog": "Catálogo"
    },
    "label": {
      "type": "Tipo",
      "name": "Nome",
      "description": "Descrição",
      "field": "Campo",
      "label": "Etiqueta ",
      "parent": "Pai",
      "newCatalogType": "novo tipo de catálogo",
      "newCatalog": "Novo catálogo",
      "code": "Código",
      "addDefinition": "Adicionar definição",
      "newDefinition": "Nova definição",
      "extaFilds": "Campos de usuário adicionais",
      "addNameTraslation": "Adicionar tradução"
    },
    "validations": {
      "exists": "O registro já existe",
      "letterNumberhyphen": "Somente letras, números e hifens são permitidos"
    },
    "messages": {
      "languageExist": "O idioma já foi adicionado"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Campos de contribuinte",
      "enabled": "Habilitado"
    },
    "header": {
      "fieldCode": "Código",
      "fieldName": "Nome",
      "fieldSection": "Seção",
      "actions": "Habilitado"
    },
    "messages": {
      "savedSucessfully": "Informação armazenada com sucesso"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Api Keys"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Nova Chave",
      "expiration": "Data de expiração",
      "your-pat": "Seu novo token de acesso pessoal",
      "revoke-token": "Revogar Token"
    },
    "validations": {
      "name": "O nome da chave de API é obrigatório",
      "expiration": "A data de expiração é obrigatória"
    },
    "message": {
      "key-created": "Certifique-se de salvá-lo - você não poderá acessá-lo novamente.",
      "confirm-revoke": "Tem certeza de que deseja revogar o token?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Logs de eventos",
      "command-title": "Logs de ações",
      "query-title": "Logs de consulta",
      "http-title": "LOGS Http",
      "application": "Aplicativo",
      "security": "Segurança"
    },
    "label": {
      "dateFrom": "Data de",
      "dateTo": "Data Até",
      "user": "Do utilizador",
      "commandName": "Nome do comando",
      "successfullyExecuted": "Execução Bem Sucedida",
      "aggregateName": "Consulta de Nome",
      "queryName": "Nome da entidade",
      "eventName": "Nome do evento",
      "httpMethod": "Método Http",
      "httpStatusCode": "Código de status Http"
    },
    "header": {},
    "validations": {
      "dateRequired": "Esta data é obrigatória",
      "dateToGreaterThan": "A data deve ser maior que a data de início",
      "dateLessThreeMonths": "A data deve ser inferior a 3 meses a partir da data de início"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Desative a autenticação de dois fatores (2FA)",
      "disable": "Desativar 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "Esta ação desativa apenas 2FA.",
      "alert-2": "Desativar 2FA não altera as chaves usadas em aplicativos autenticadores.",
      "alert-3": "Se você deseja alterar a chave usada em um aplicativo autenticador, você deve:",
      "alert-4": "redefina as chaves do autenticador.",
      "success": "2fa foi desativado. Você pode reativar 2fa ao configurar um aplicativo autenticador"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configurar aplicativo autenticador",
      "verification-code": "Código de verificação",
      "verification-code-digit": "Dígito {{position}} de {{total}}",
      "verify": "Verificar",
      "manual-key": "Chave de configuração manual",
      "copy-key": "Copiar chave",
      "key-copied": "Chave copiada para a área de transferência.",
      "key-copied-button": "Copiado",
      "copy-unavailable": "Não foi possível copiar a chave. Copie-a manualmente.",
      "security-recommendations": "Recomendações de segurança",
      "security-recommendations-detail": "Guarde os códigos de recuperação em um local seguro e não compartilhe a chave de configuração."
    },
    "validations": {
      "code": "Código de verificação é obrigatório"
    },
    "message": {
      "instruction-1": "Baixe um aplicativo autenticador como o Microsoft Authenticator para",
      "and": "S ",
      "or": "ou",
      "for": "para ",
      "instruction-2": "Leia o código QR ou insira esta chave",
      "instruction-3": "dentro de seu aplicativo autenticador. Espaços e separadores não importam.",
      "instruction-4": " Depois de escanear o código QR ou inserir a chave acima, seu aplicativo de autenticação fornecerá um código exclusivo. Digite o código no campo de confirmação abaixo."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Códigos de Recuperação",
      "available-once": "Guarde-os agora: eles não serão exibidos integralmente novamente."
    },
    "message": {
      "save-security-codes": "Guarde esses códigos em um lugar seguro.",
      "if-you-lose": "Se você perder seu dispositivo e não tiver os códigos de recuperação, perderá o acesso à sua conta."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Gerar códigos de recuperação para autenticação de dois fatores (2FA)",
      "generate": "Gerar Códigos de Recuperação"
    },
    "validations": {},
    "message": {
      "alert-1": "Coloque esses códigos em um lugar seguro.",
      "alert-2": " Se você perder seu dispositivo e não tiver os códigos de recuperação, perderá o acesso à sua conta.",
      "alert-3": "A geração de novos códigos de recuperação não altera as chaves usadas no aplicativo autenticador. Se você deseja alterar a chave usada no aplicativo autenticador, você deve",
      "alert-4": " redefina suas chaves de autenticação."
    }
  },
  "security-login": {
    "title": {
      "login": "Login "
    },
    "label": {
      "username": "Usuario",
      "password": "Senha",
      "rememberMe": "Lembre de mim",
      "loginButton": "Iniciar sessão",
      "passwordRecovery": "Recuperar senha",
      "notRegistered": "não registrado ainda?",
      "signup": "cadastre-se",
      "loginAlternative": "ou",
      "forgotPassword": " Você esqueceu sua senha ?",
      "next": "Próximo",
      "forgotPasswordInstructions": "Digite seu nome de usuário e enviaremos um e-mail com as instruções para recuperar",
      "externalLogin": "Login Externo",
      "captcha-placeholder": "Digite o captcha"
    },
    "validations": {
      "usernameRequired": "O campo do usuário é obrigatório",
      "passwordRequired": "Senha requerida",
      "captchaValidationRequired": "A validação de captcha é necessária"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Autenticação de dois fatores",
      "login-recovery": "Recuperar código de verificação"
    },
    "label": {
      "twoFactorCode": "Código autenticador",
      "recoveryCode": "Código de recuperação",
      "rememberBrowser": "Lembre-se deste navegador",
      "verificationCodeInstructions": "Digite o código de seis dígitos do seu aplicativo autenticador para continuar.",
      "loginButton": "Iniciar sessão",
      "loginRecovery": "Login com código de recuperação"
    },
    "message": {
      "no-access": "Você não tem acesso ao seu dispositivo de autenticação? você pode",
      "trustedBrowser": "Ignore a verificação neste navegador confiável.",
      "recovery-requested": " Você solicitou o login com um código de recuperação. Este login não será lembrado até que você forneça um código de aplicativo de autenticação ao fazer login ou desative o 2FA e faça login novamente."
    },
    "validations": {
      "twoFactorCode": "O campo do código de autenticação é obrigatório",
      "recoveryCode": "O campo do código de recuperação é obrigatório"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Recuperar senha",
      "changePassword": "Alterar a senha",
      "userName": "Usuario",
      "newPassword": "Nova senha",
      "repeatPassword": "repetir a senha",
      "returnLogin": "Voltar para o login"
    },
    "message": {
      "email-sended": "Email de recuperação de senha enviado",
      "password-changed": "A senha foi alterada com sucesso"
    },
    "validations": {
      "newPassword": "A nova senha deve ter pelo menos 6 caracteres",
      "passwordEqual": "As senhas não coincidem"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Instale o aplicativo autenticador",
      "reset": "Redefinir a chave do autenticador",
      "configure": "Configurar aplicativo autenticador"
    },
    "validations": {},
    "message": {
      "alert-1": "Se você redefinir a chave do autenticador, o aplicativo do autenticador não funcionará até que você o reconfigure.",
      "alert-2": "Este processo desativa 2FA até que você verifique seu aplicativo autenticador.",
      "alert-3": "Se você não concluir a configuração do aplicativo autenticador, poderá perder o acesso à sua conta.",
      "success": "Sua chave do autenticador foi redefinida e você precisará configurar o aplicativo do autenticador usando a nova chave."
    }
  },
  "tfa": {
    "title": {
      "page": "Autenticação de fator duplo"
    },
    "label": {
      "title": "Autenticação de dois fatores (2FA)",
      "authenticator-app": "Aplicativo Authenticator",
      "setup-authenticator": "Configurar aplicativo autenticador",
      "add-authenticator": "Adicionar aplicativo autenticador",
      "reset-authenticator": "Reinicie o aplicativo autenticador",
      "reset-recovery-codes": "Redefinir códigos de recuperação",
      "disable-2fa": "Desativar 2FA",
      "forget-this-browser": "Esqueça este navegador",
      "status-enabled": "Ativado",
      "status-disabled": "Não configurado",
      "recovery-codes-remaining": "códigos de recuperação disponíveis",
      "danger-zone": "Ações de alto impacto"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Este navegador foi esquecido. Quando você fizer login novamente neste navegador, será solicitado o seu código 2fa.",
      "no-codes-left-1": "Você não tem códigos de recuperação disponíveis.",
      "no-codes-left-2": "Deve",
      "no-codes-left-3": "gerar um novo conjunto de códigos de recuperação",
      "no-codes-left-4": "antes de fazer o login com um código de recuperação.",
      "some-codes-left-1": "Tem",
      "some-codes-left-2": "código (s) de recuperação disponíveis.",
      "some-codes-left-3": "Deve",
      "some-codes-left-4": "gerar um novo conjunto de códigos de recuperação"
    }
  },
  "roles": {
    "account_reports": "Consulta de conta",
    "catalogs_admin": "Gerente de Catálogo",
    "details_reports": "Detalhe de relatórios",
    "environments_admin": "Gerente de Variáveis ??de Ambiente",
    "forms_admin": "Form Manager",
    "management_report_admin": "Gerente de Relatório",
    "notifications_admin": "Gerente de Notificações",
    "system_auditor": "Auditor de Sistema",
    "taxpayer_reports": "Consultas de contribuintes",
    "taxpayers_admin": "Administrador de contribuintes",
    "payments_admin": "Gerente de Pagamentos",
    "taxpayers_approver": "Aprovador de contribuintes",
    "taxreturn_approver": "Aprovador de declarações",
    "taxreturn_reports": "Consultas de declarações",
    "tfa_admin": "Administrador 2FA",
    "users_admin": "Gerente de Usuário",
    "current_account_admin": "Gerente de conta atual"
  },
  "amendment-create": {
    "title": {
      "dialog-confirm": "Enviar declaração"
    },
    "label": {
      "taxReturn": "Número de declaração a retificar"
    },
    "messages": {
      "confirm": "Tem certeza de que deseja realizar esta ação?"
    }
  },
  "statement-submit-amendment": {
    "title": {
      "page": "Rectificar declaração"
    },
    "label": {
      "taxReturn": "Demonstração",
      "year": "Período"
    },
    "messages": {},
    "validations": {},
    "button": {
      "file": "Retificar"
    }
  },
  "statement-submit-statement": {
    "title": {
      "page": "Apresentar declaração de impostos",
      "subtitle": "Por favor, preencha as informações para identificar o imposto e o período a declarar"
    },
    "label": {
      "fileStatement": "Declaração de imposto de renda",
      "taxReturn": "Declaração de impostos",
      "year": "Período"
    },
    "messages": {
      "formVersionNotFound": "Uma versão atual e ativa não foi encontrada",
      "taxReturnExist": "A declaração já existe para este período",
      "validPeriod": "O período selecionado não é válido para este imposto"
    }
  },
  "taxreturns": {
    "title": {
      "dialog-confirm": "Enviar declaração"
    },
    "messages": {
      "successfully": "A declaração com ponto final [period] foi enviada com sucesso em [createDate]",
      "successfullyApprovalRequired": "Tendo a declaração modificativa reduziu o imposto, ela será submetida a um processo de revisão para aprovação ou rejeição pela administração tributária.",
      "confirm": "Tem certeza de que deseja realizar esta ação?",
      "backToHome": "Voltar ao início"
    }
  },
  "taxes": {
    "title": {
      "page": "Gerenciar impostos"
    },
    "label": {
      "name": "Nome",
      "rateType": "Tipo de taxa",
      "shortName": "Nome curto",
      "code": "Código",
      "newButton": "Novo",
      "saveButton": "Manter",
      "tabEditTax": "em geral",
      "tabRates": "Honorários",
      "tabPeriodicity": "Periodicidade",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "value": "Valor",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "header": {
      "code": "Código",
      "name": "Nome",
      "rateType": "Tipo de taxa",
      "value": "Valor",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "shortName": "Nome curto",
      "actions": "Ações",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "validations": {
      "rateTypeRequired": "O campo do tipo de taxa é obrigatório",
      "shortNameRequired": "O campo do nome curto é obrigatório",
      "codeRequired": "O campo do código é obrigatório",
      "valueLessThan100": "O campo de valor deve ser menor que 100%",
      "valueRequired": "O campo de valor é obrigatório",
      "dateFromRequired": "O campo data de é obrigatório",
      "dateToRequired": "O campo data é obrigatório",
      "filingDueDayRequired": "O campo do dia de expiração é obrigatório",
      "periodicityTypeRequired": "O campo do tipo de periodicidade é obrigatório"
    },
    "messages": {
      "savedSuccessfully": "Foi salvo com sucesso",
      "deletedSuccessfully": "Foi removido com sucesso",
      "error": "Erro"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Gerenciar relatórios de operações",
      "warning": "Aviso"
    },
    "label": {
      "operation": "Operação",
      "report": "Relatório"
    },
    "header": {
      "operation": "Operação",
      "report": "Relatório",
      "actions": "Ações"
    },
    "messages": {
      "removeReportOperation": "Você tem certeza que quer apagar isso?"
    }
  },
  "report-cells": {
    "title": {
      "page": "Caixas"
    },
    "label": {
      "code": "Código da caixa",
      "name": "Caixa de Nome",
      "description": "Descrição",
      "formula": "Fórmula",
      "order": "Pedido",
      "type": "Tipo",
      "numeric": "Numérico",
      "currency": "Moeda",
      "date": "Data",
      "list": "Pronto",
      "text": "Texto",
      "catalogType": "Tipo de Catálogo"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Tem certeza que deseja deletar?"
    }
  },
  "reports": {
    "title": {
      "page": "Gerenciar relatórios",
      "report": "Relatório",
      "versions": "Versões"
    },
    "label": {
      "name": "Nome",
      "shortName": "Nome curto",
      "code": "Código",
      "newButton": "Novo",
      "saveButton": "Manter",
      "tabEditReport": "em geral",
      "tabPeriodicity": "Periodicidade",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "header": {
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "actions": "Ações",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "validations": {
      "shortNameRequired": "O campo do nome curto é obrigatório",
      "codeRequired": "O campo do código é obrigatório",
      "dateFromRequired": "O campo data de é obrigatório",
      "dateToRequired": "O campo data é obrigatório",
      "filingDueDayRequired": "O campo do dia de vencimento é obrigatório",
      "periodicityTypeRequired": "O campo do tipo de periodicidade é obrigatório"
    },
    "messages": {
      "savedSuccessfully": "Foi salvo com sucesso",
      "deletedSuccessfully": "Foi removido com sucesso",
      "error": "Erro"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Conta corrente",
      "amendingCredit": "Consulta de saldo",
      "currentAccountTransaction": "Detalhe de transações",
      "transactionAdjustment": "Ajuste de equilíbrio"
    },
    "label": {
      "tax": "Imposto",
      "taxCode": "Código de Imposto",
      "period": "Período",
      "taxAmount": "Valor do imposto",
      "penalty": "Multa",
      "interest": "Taxas",
      "taxArrears": "Mora",
      "total": "Total",
      "expirationDate": "Data de validade",
      "accountType": "Tipo de conta",
      "balance": "Equilíbrio",
      "date": "Data",
      "transactionType": "Tipo de transação",
      "value": "Valor",
      "document": "Documento",
      "justification": "Justificação",
      "credit": "Crédito",
      "debit": "Débito"
    },
    "dialog": {},
    "messages": {},
    "validations": {}
  },
  "taxpayer-payments": {
    "title": {
      "page": "Inquérito de pagamento",
      "pagePayments": "Registro de pagamento",
      "selectTaxReturn": "Selecione declaração de imposto"
    },
    "label": {
      "registerPayment": "Registro de pagamento",
      "amountTaxReturn": "Valor da declaração",
      "totalDebt": "Dívida total",
      "tax-id": "CPF/CNPJ",
      "name": "Nome",
      "date-from": "Data de",
      "date-to": "Data Até",
      "date-payment": "Dia do pagamento",
      "payment-number": "Número de pagamento",
      "exchange-rate": "Taxa de câmbio",
      "local-amount": "Valor em moeda local",
      "tax": "Imposto",
      "amount": "Resultar",
      "swiftNumber": "Número de confirmação SWIFT"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Pagamento cadastrado com sucesso em [createDate]",
      "paymentInformationWarning": "Caso não seja fornecida a informação relativa ao código Swift, o pagamento não poderá ser corretamente identificado e a declaração será considerada não paga"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Consulta contribuinte"
    },
    "label": {
      "name": "Nome",
      "nit": "CPF/CNPJ",
      "county": "País",
      "personType": "Tipo de pessoa",
      "email": "e-mail"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Tipo de pessoa",
      "businessName": "Nome ou nome da empresa",
      "fullName": "Nome completo",
      "id": "Número de identificação",
      "taxNumber": "Número de identificação fiscal",
      "phoneNumber": "Número de telefone",
      "domicile": "Endereço",
      "department": "Departamento / Província / Estado",
      "addContact": "Adicionar contato",
      "operations": "Operações",
      "contacts": "Contatos:",
      "taxVector": "Vetor de impostos",
      "reportVector": "Relatórios",
      "generalData": "Em geral",
      "tax": "Imposto",
      "taxObligation": "Imposto",
      "report": "Relatório",
      "website": "Site web",
      "idTax": "Número de identificação fiscal do país de residência",
      "contactName-tax": "Nome do contato principal",
      "docNumberContact-tax": "Número de identificação de contato",
      "contactTaxIdNumber-tax": "Número de identificação fiscal do contacto no país de residência",
      "phoneNumberContact-tax": "Número de telefone do contato no país de residência",
      "email-tax": "Email de contato",
      "documents": "Documentos",
      "docCompanyRegistrationNumber": "Documento de registro da empresa",
      "docLocalContact": "Documento de identidade do contato no país de residência",
      "acceptance": "Aceitação",
      "taxpayerRequest": "Registro POSS",
      "confirmTerms": "aceita termos e Condições",
      "terms": "Lorem ipsum dor sente-se amet consectetur adipiscing elit per",
      "locale": "Idioma pré-definido",
      "close": "Sair",
      "acquirerId": "Identificação do adquirente",
      "acquirerCountry": "País do adquirente",
      "terminalId": "Identificação do terminal",
      "merchantCategoryCode": "Código da categoria do comerciante",
      "merchantId": "Identificação do comerciante",
      "documentNumberCountryResidence": "Número do documento no país de residência"
    },
    "vector": {
      "label": {
        "tax": "Imposto",
        "expiration": "Dia de expiração",
        "periodicity": "Periodicidade",
        "startOperation": "Início de operação"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "São necessários mais contactos",
      "operations": "É necessária pelo menos uma operação",
      "selectOperations": "Selecione as operações correspondentes",
      "withoutOperations": "Sem operações",
      "withoutOperationsVector": "Devido às operações selecionadas, você não tem um vetor de impostos para apresentar",
      "withoutOperationsReport": "Devido às suas operações selecionadas, não possui relatórios para apresentar.",
      "withoutDocuments": "Não há definição de arquivo",
      "successRegistrationTaxpayerTitle": "Sua solicitação de registro foi concluída e recebida com sucesso.",
      "successRegistrationTaxpayerSubTitle": "Você será analisado e receberá seus resultados por e-mail.",
      "email-tax-info": "Este endereço de correio eletrónico será utilizado para receber o seu nome de utilizador e a sua palavra-passe assim que a sua candidatura for aprovada. Verifique se as informações fornecidas estão correctas.",
      "contactsList": "Registre seus contatos secundários aqui. Você deve cadastrar pelo menos um",
      "noContacts": "Nenhum contato foi especificado"
    },
    "validations": {
      "acceptance": "O campo deve ser selecionado",
      "formComplete": "Preencha todo o formulário"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Solicitações de contribuintes",
      "approve": "Aprovar Pedido",
      "reject": "Rejeitar pedido",
      "request-additional-info": "Solicite informações adicionais"
    },
    "label": {
      "date-from": "Data de",
      "date-to": "Data Até",
      "request-type": "Tipo de pedido",
      "request": "Solicitação",
      "type": "Tipo",
      "taxpayer": "Contribuinte",
      "state": "Estado",
      "approve": "Passar",
      "reject": "Rejeitar",
      "request-additional-info": "Solicite informações adicionais",
      "comments": "Comentários",
      "reason": "Causa",
      "cancellationDate": "Data de cancelamento"
    },
    "message": {
      "approved": "Aplicação aprovada",
      "rejected": "Pedido rejeitado",
      "request-additional-info": "Solicite informações adicionais",
      "unsubscribe-request": "Sua inscrição foi recebida, você será notificado se sua inscrição foi aprovada ou rejeitada."
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Ver relatórios de declarações",
      "subtitle": "Lista de documentos armazenados",
      "amendment": "Apresentar uma declaração de impostos retificativa"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxreturnNumber": "Número da Declaração",
      "country": "País",
      "formId": "Nome do formulario",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "name": "Nome do contribuinte",
      "period": "Período",
      "periodFrom": "Data de",
      "periodTo": "Data Até",
      "active": "Ativo",
      "overview": "em geral",
      "taxreturn": "Declaração",
      "createDate": "Data",
      "approve": "Aprovado",
      "comments": "Comentários"
    },
    "header": {
      "actions": "Ações",
      "nit": "CPF/CNPJ",
      "name": "Nome do contribuinte",
      "taxReturnNumber": "Número da Declaração",
      "createDate": "Data",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "form": "Forma",
      "period": "Período",
      "active": "Ativo",
      "rejectionReason": "Razão para rejeição"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Atualizar registro"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Retirar-se"
    }
  },
  "form-administration": {
    "title": {
      "page": "Formulário de Administração para Declarações",
      "form": "Forma",
      "versions": "Versões"
    },
    "label": {
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "tax": "Imposto",
      "numberModifications": "Número de emendas",
      "amendmentApprovalRequired": "Emendas requerem aprovação",
      "form": "Forma",
      "versions": "Versões"
    },
    "header": {
      "actions": "Ações",
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "tax": "Imposto"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?",
      "noCellDefined": "Prezado contribuinte, este formulário tem uma definição incompleta, entre em contato com o administrador"
    }
  },
  "report-file": {
    "title": {
      "page": "Anexo de Relatório Complementar",
      "dialog": "Relatório já existe",
      "dialog-confirm": "Enviar relatório"
    },
    "label": {
      "header": "Cabeceira",
      "description": "Descrição",
      "type": "Tipo",
      "file": "Relatório suplementar",
      "loading": "Carregando ...",
      "definition": "Definição de arquivo (.csv, .xls, .xlsx)"
    },
    "button": {
      "attachment": "Anexar relatório"
    },
    "messages": {
      "dialog": "Já foi submetido um relatório para o período selecionado, deseja substituir o relatório existente por uma nova versão?",
      "confirm": "Tem certeza de que deseja realizar esta ação?",
      "successfully": "O relatório suplementar com ponto [period] foi enviado com sucesso em [createDate]",
      "backToHome": "Voltar ao início"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Em processamento",
      "error": "Erro",
      "accepted": "Aceitaram",
      "processed": "Processado"
    },
    "title": {
      "page": "Consulta de relatórios"
    },
    "label": {
      "reportNumber": "Número do relatório",
      "reportType": "Tipo de relatório",
      "operations": "Tipo de operação",
      "taxpayerNumber": "Número de identificação Tributária",
      "taxpayerName": "Nome do contribuinte",
      "registrationDate": "Data de registro",
      "period": "Período",
      "reportName": "Nome do relatório",
      "record": "Valores",
      "index": "Fileira",
      "type": "Tipo",
      "active": "Ativo",
      "taxReportState": "Estado"
    }
  },
  "report-selection": {
    "label": {
      "fileReport": "Enviar relatório suplementar",
      "report": "Relatório",
      "year": "Período"
    },
    "messages": {
      "reportVersionNotFound": "Versão do relatório não encontrada"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "Veja as declarações"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxreturnNumber": "Número da Declaração",
      "country": "País",
      "formId": "Forma",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "name": "Nome do contribuinte",
      "period": "Período",
      "periodFrom": "Data de",
      "periodTo": "Data Até",
      "active": "Ativo",
      "overview": "em geral",
      "taxreturn": "Declaração",
      "createDate": "Data",
      "approve": "Aprovado",
      "comments": "Comentários"
    },
    "header": {
      "actions": "Ações",
      "nit": "CPF/CNPJ",
      "name": "Nome do contribuinte",
      "taxReturnNumber": "Número da Declaração",
      "createDate": "Data",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "form": "Forma",
      "period": "Período",
      "active": "Ativo",
      "rejectionReason": "Razão para rejeição"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "form-cells": {
    "title": {
      "page": "Caixas",
      "serviceParameters": "Parâmetros de serviço"
    },
    "label": {
      "code": "Código da caixa",
      "name": "Caixa de Nome",
      "description": "Descrição",
      "section": "Seção",
      "formula": "Fórmula",
      "order": "Pedido",
      "type": "Tipo",
      "service": "Serviço",
      "mandatory": "Obrigatório",
      "editable": "Editável",
      "visible": "Visível",
      "cellPurpose": "Finalidade da célula",
      "numeric": "Numérico",
      "currency": "Moeda",
      "date": "Data",
      "list": "Pronto",
      "text": "Texto",
      "catalogType": "Tipo de Catálogo",
      "parameterName": "Nome",
      "addParameter": "Adicionar Parâmetro"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?"
    }
  },
  "taxpayer-alternate-user": {
    "title": {
      "page-add": "Novo usuário alternativo",
      "page-list": "Usuários alternativos"
    },
    "label": {
      "add-user": "Adicionar usuário"
    }
  },
  "login": {
    "hero": {
      "title": "Modernização e Cooperação para os Desafios da Tributação na",
      "name": "Economia Digital"
    },
    "block1": {
      "title": "Uma Plataforma Estratégica",
      "text": "para Administrações Tributárias"
    },
    "block2": {
      "title": "Uma Ferramenta Eficaz",
      "text": "para Gerenciar a Tributação de Empresas Sem Representação Física na Jurisdição."
    },
    "block3": {
      "title": "Projetada para Facilitar",
      "text": "o Registro, a Declaração e o Pagamento de Impostos por Fornecedores Digitais Estrangeiros."
    },
    "links": {
      "title": "Mais Informações",
      "link1": "Materiais e Procedimentos",
      "link2": "Sobre o CIAT",
      "link3": "Sobre o PITAA"
    }
  },
  "appMenu": {
    "taxpayer-profile-update": "Atualizar registro",
    "taxpayer-payment-view": "Veja pagamentos",
    "unsubscribe-request-taxpayer": "Cancelar inscrição",
    "taxpayer-payment-record": "Registro de pagamento",
    "taxpayer-amending-credit": "Saldo da Dívida",
    "security-taxpayer": "Segurança",
    "apikey": "Chaves de API",
    "two-factor-authentication-taxpayer": "Autenticação de dois fatores",
    "taxpayer-profile": "Perfil",
    "inbox-notifications": "Notificações",
    "file-tax-statements": "Enviar declaração de imposto",
    "statements": "Declarações de imposto",
    "file-report": "Enviar relatório suplementar",
    "taxpayer-taxreturn-payments": "Pagamentos",
    "amendment-taxreturn": "Alteração da declaração de imposto",
    "taxpayer-tax-returns": "Listar declarações de imposto",
    "taxpayer-report-details": "Listar Relatórios Suplementares",
    "delegates": "Delegados",
    "delegate-list": "Consultar delegados"
  },
  "delegate": {
    "title": "Registrar delegado",
    "description": "Informe os dados da pessoa que poderá operar em nome do contribuinte.",
    "formTitle": "Dados do delegado",
    "fullName": "Nome completo",
    "fullNamePlaceholder": "Nome e sobrenome",
    "phoneNumber": "Telefone",
    "phoneNumberPlaceholder": "Número de telefone",
    "documentNumber": "Número do documento",
    "documentNumberPlaceholder": "Documento de identidade",
    "email": "E-mail",
    "emailPlaceholder": "Endereço de e-mail",
    "comments": "Comentários",
    "commentsPlaceholder": "Observações adicionais",
    "register": "Registrar delegado",
    "successMessage": "Registro concluído. Um e-mail de ativação foi enviado ao delegado.",
    "errorMessage": "Ocorreu um erro ao registrar o delegado. Verifique os dados e tente novamente.",
    "activationNote": "O delegado receberá um e-mail com um link para definir sua senha. O usuário é o código sequencial atribuído pelo sistema.",
    "listTitle": "Delegados registrados",
    "noDelegates": "Você ainda não registrou delegados",
    "login": "Usuário",
    "inactive": "Inativo",
    "active": "Ativo",
    "previewDescription": "Seus usuários delegados",
    "previewMore": "Mostrando {{shown}} de {{total}} delegados",
    "viewAll": "Ver todos"
  }
}
